// src/stone/illustrations/ShieldIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Shieldillustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "currentcolor", d: "M0 0h64v64H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          d: "M32 12.002A2.002 2.002 0 1 0 32 8a2.002 2.002 0 0 0 0 4.003Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M50 12.002A2.002 2.002 0 1 0 50 8a2.002 2.002 0 0 0 0 4.003"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          d: "M14 12.002A2.002 2.002 0 1 0 14 8a2.002 2.002 0 0 0 0 4.003ZM32 56a2.001 2.001 0 1 0 0-4.002A2.001 2.001 0 0 0 32 56Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M43.999 36A11.999 11.999 0 1 1 20 36V15.997H44z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M49.982 7.999H14.018a2.02 2.02 0 0 0-2.009 2.03V36.01a19.997 19.997 0 0 0 20.267 19.998c10.99-.142 19.732-9.304 19.732-20.295V10.029a2.02 2.02 0 0 0-2.026-2.03m-1.984 28A16.003 16.003 0 0 1 20.6 47.469a16 16 0 0 1-4.602-11.469V12h32z"
        }
      )
    ]
  }
);
var ShieldIllustration_default = Shieldillustration;

export {
  ShieldIllustration_default
};
